import styled from 'styled-components';

export const MainDashboardContainerStyled = styled.div`
  .title_layout {
    margin-bottom: 19px;
  }
`;
